import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';

import './ValueProps.less';

export const CNAME = 'ValueProps';

const ValuePropsItem = ({ title, blurb, icon, isTablet }) => (
  <li className={`${CNAME}__item col-xs-12 col-sm-6 col-md-3`}>
    <div className={`${CNAME}__item-icon`}>
      {icon}
    </div>
    <div className={cnames(`${CNAME}__item-text`, { [`${CNAME}__item-text--isTablet`]: isTablet })} >
      <h3 className={`${CNAME}__title`}>{title}</h3>
      <p className={`${CNAME}__blurb small`}>{blurb}</p>
    </div>
  </li>
);

ValuePropsItem.propTypes = {
  title: PropTypes.string,
  blurb: PropTypes.string,
  icon: PropTypes.func,
  isTablet: PropTypes.bool.isRequired
};

ValuePropsItem.defaultProps = {
  title: '',
  blurb: '',
  icon: '',
  isTablet: false
};

export default ValuePropsItem;
